module.exports = __webpack_public_path__ + "img/banner11.91046e88.jpg";